import {alpha, Link, Stack, Theme, useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, {Dispatch, FC, SetStateAction} from "react";
import {Trans, useTranslation} from "react-i18next";
import {RoutePaths, StorageConstants} from "../../../../util/constants";
import {Link as RouterLink} from "react-router-dom";
import Box from "@mui/material/Box";

interface IProps {
    setCookiesAllowed: Dispatch<SetStateAction<string | null>>
}

const CookiesBanner: FC<IProps> = ({setCookiesAllowed}) => {
    const theme = useTheme()
    const {t} = useTranslation()
    const matchesMd = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"))
    const matchesSm = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"))

    const handleAllowCookiesClick = () => {
        localStorage.setItem(StorageConstants.COOKIES_ALLOWED, "yes")
        setCookiesAllowed("yes")
    }

    return (
        <Box sx={{
            position: 'fixed',
            bottom: '1.25em',
            left: '50%',
            transform: 'translateX(-50%)',
            width: {xs: '92%', sm: '84%', md: '68%', lg: '58%'},
            zIndex: theme.zIndex.drawer - 1,
            backgroundColor: alpha(theme.palette.primary.main, .84),
            boxShadow: 5,
            backdropFilter: 'blur(10px)',
            color: theme.palette.secondary.main,
            borderRadius: 2.5,
            px: {xs: 1.5, sm: 2, md: 2.5},
            py: {xs: 1.5, sm: 1.75},
        }}>
            <Stack
                direction={{xs: 'column', md: 'row'}}
                spacing={{xs: 1.25, md: 2}}
                alignItems={{xs: 'stretch', md: 'center'}}
                justifyContent="space-between"
            >
                <Box sx={{flex: 1, minWidth: 0}}>
                    <Typography
                        color="secondary"
                        variant={matchesMd ? 'subtitle1' : 'subtitle2'}
                        fontWeight={600}
                        sx={{
                            textAlign: {xs: 'center', md: 'left'},
                            lineHeight: 1.25,
                        }}
                    >
                        <Trans i18nKey="cookie_policy"
                               components={[<Link color="secondary" sx={{cursor: 'pointer'}} component={RouterLink}
                                                  to={RoutePaths.PRIVACY}/>]}/>
                    </Typography>
                </Box>

                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent={{xs: 'center', md: 'flex-end'}}
                    flexShrink={0}
                    sx={{minWidth: matchesSm ? 'fit-content' : 0, alignSelf: {xs: 'center', md: 'center'}}}
                >
                    <Button
                        variant='contained'
                        size='medium'
                        color='secondary'
                        sx={{whiteSpace: 'nowrap'}}
                        onClick={handleAllowCookiesClick}
                    >
                        {t('accept')}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    )
}

export default CookiesBanner
